export default {
    approvalFlow: {
        cooperative: {
            delete: 'Coöperatie Verwijderen',
            deactivate: 'Coöperatie Deactiveren',
            activate: 'Coöperatie Activeren',
            add: 'Nieuwe Coöperatie Toevoegen',
            edit: 'Coöperatie Bewerken',
            cooperativeName: 'Coöperatie Naam',
            cooperativeNameTT: 'De wettelijk geregistreerde naam van de coöperatie, gebruikt in alle compliance records en rapporten.',
            membershipPlan: 'Lidmaatschap Plan',
            membershipPlanTT: 'Het plan of overeenkomst dat de voorwaarden en bepalingen van het lidmaatschap in de coöperatie schetst.',
            primaryContact: 'Primair Contact',
            primaryContactTT: 'Contactnaam, email, telefoon.',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            phoneNumber: 'Telefoonnummer',
            email: 'Email',
            location: 'Locatie',
            locationTT: 'Filter op locatietekst (land/provincie/stad).',
            country: 'Land',
            countryTT: 'Het land waar de coöperatie wettelijk geregistreerd is en opereert. Dit helpt rapporten af te stemmen op nationale regelgeving.',
            provinceState: 'Provincie/Staat',
            provinceStateTT: 'De provincie of staat waar de coöperatie wettelijk geregistreerd is en opereert. Dit helpt rapporten af te stemmen op regionale regelgeving.',
            regionDistrict: 'Regio/District',
            regionDistrictTT: 'De regio of district waar de coöperatie gevestigd is. Dit helpt bij nauwkeurige identificatie op gemeenschapsniveau.',
            villageTownCity: 'Dorp/Stad',
            villageTownCityTT: 'De naam van de lokale nederzetting (dorp, stad of stad) waar de coöperatie gevestigd is. Dit zorgt voor nauwkeurige identificatie op gemeenschapsniveau.',
            address: 'Adres',
            addressTT: 'Het volledige fysieke of postadres van de coöperatie. Dit moet straatdetails bevatten, indien beschikbaar, voor nauwkeurige referentie in rapporten.',
            businessInformation: 'Bedrijfsinformatie',
            interestedCommodities: 'Geïnteresseerde Commodities/Producten',
            interestedCommoditiesTT: 'Toont de productcode en naam die geassocieerd zijn met het rapport. Dit veld helpt gebruikers begrijpen welk product het rapport betreft.',
            coffee: 'Koffie',
            cacao: 'Cacao',
            landRegistered: 'Hoeveel land wordt geregistreerd? (in hectares)',
            userType: 'Gebruikerstype',
            userTypeTT: 'Filter resultaten op Coöperatie rol/type.',
            exporter: 'Exporteur',
            cooperative: 'Coöperatie',
            bothOfThem: 'Beide',
            uploadLogo: 'Upload kopie van Logo',
            uploadLogoButton: 'LOGO UPLOADEN',
            enterHere: 'Voer hier in',
            select: 'Selecteer',
            cooperativeNameRequired: 'Coöperatie naam is verplicht',
            firstNameRequired: 'Voornaam is verplicht',
            emailRequired: 'Email is verplicht',
            invalidEmail: 'Ongeldige email',
            required: 'Verplicht',
            pleaseUploadValidImage: 'Upload een geldig afbeeldingsbestand',
            errorPreparingData: 'Fout bij het voorbereiden van gegevens',
            cancel: 'Annuleren',
            save: 'Opslaan',
            update: 'Bijwerken',

            // List page translations
            listOfCooperatives: 'Lijst van Coöperaties',
            addCooperatives: 'Coöperaties Toevoegen',
            loadingData: 'Gegevens laden...',
            search: 'Zoeken',
            type: 'Type',
            cooperativeTypeInformation: 'Coöperatie Type Informatie',
            all: 'Alle',
            
            of: 'van',
            active: 'Actief',
            unregistered: 'Niet Geregistreerd',
            deactivated: 'Gedeactiveerd',
            view: 'Bekijken',
            confirmDelete: 'Verwijdering Bevestigen',
            areYouSureDeleteCooperative: 'Weet je zeker dat je deze coöperatie wilt verwijderen?',
            updatedSuccessfully: 'Succesvol bijgewerkt',
            createdSuccessfully: 'Succesvol aangemaakt',
            errorFetchingCooperativeDetails: 'Fout bij het ophalen van coöperatie details',
            errorSavingCooperative: 'Fout bij het opslaan van coöperatie',
            errorFetchingCooperativesData: 'Fout bij het ophalen van coöperatie gegevens',
            cooperativeDeactivatedSuccessfully: 'Coöperatie succesvol gedeactiveerd',
            errorDeactivatingCooperative: 'Fout bij het deactiveren van coöperatie',
            cooperativeDeletedSuccessfully: 'Coöperatie succesvol verwijderd',
            errorDeletingCooperative: 'Fout bij het verwijderen van coöperatie',
            // Table headers
            noOfFarms: 'No. Boerderijen',
            cropsProducts: 'Gewassen/Producten',
            
            status: 'Status',
            statusTT: 'Operationele status van de coöperatie in het systeem (bijv. Actief, Gedeactiveerd, Niet Geregistreerd).',
            actions: 'Acties',
            // Cooperative types
            cooperativeAndExporter: 'Coöperatie + Exporteur',
            // Success messages
            cooperativeActivatedSuccessfully: 'Coöperatie succesvol geactiveerd',
            back: 'Terug',
            commoditiesProducts: 'Detail Coöperatie',
            cooperativeEmail: 'Email Coöperatie',
            cooperativePhoneNumber: 'Telefoonnummer Coöperatie',
            logo: 'Logo',
            logoTT: 'Officieel beeld of logo symbool van de organisatie voor branding op rapporten/QR-pagina\'s.',
            advanced: 'Geavanceerd',
        },
    },
};
